import { mobileThreshold } from './mobileThreshold';

export const mediaQueries = {
  mobile: `@media (max-width: ${mobileThreshold - 1}px)`,
  desktop: `@media (min-width: ${mobileThreshold}px)`,
  print: '@media print',
} as const;
